import ItineraryWarningsGroup from 'components/itineraryWarningsGroup/ItineraryWarningsGroup';
import { KeyValuePairOfStringAndListOfItineraryWarning } from 'core/graphql/types';

export interface ItineraryWarningsProps {
  itineraryWarnings: KeyValuePairOfStringAndListOfItineraryWarning[];
}

const ItineraryWarnings = ({ itineraryWarnings }: ItineraryWarningsProps) => {
  let warningCount = 0;
  itineraryWarnings.forEach((x) => {
    warningCount += x.value.length;
  });
  return (
    <div>
      {itineraryWarnings.length > 0 && (
        <div className="m-1">
          <span>Itinerary Warnings</span>
          <span className="ml-2 rounded-lg bg-gray px-2 dark:bg-design-secondary-black">
            {warningCount ?? 0}
          </span>
          <div>
            {itineraryWarnings.map((warningGroup) => (
              <ItineraryWarningsGroup
                key={warningGroup.key}
                warningGroup={warningGroup.key}
                warnings={warningGroup.value}
              />
            ))}
          </div>
        </div>
      )}
    </div>
  );
};

export default ItineraryWarnings;
